export enum RuleCategory {
  DocumentRequired = 0,
  VisaWaiver = 1,
  PassportValidity = 2,
  AcceptedDocuments = 3,
  Constraint = 4,
  NoAcceptedDocuments = 5,
  OnwardTravel = 6
}
